// extracted by mini-css-extract-plugin
export default {"section":"AgentRegister_section__RyRJL","header":"AgentRegister_header__hICiL","active":"AgentRegister_active__mTcKj"};